import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { } from './highcharts'
import { } from './notification'
import netatmoService from './services/netatmoService'

Vue.config.productionTip = false

// En cas d'erreur d'habilitation lors d'un appel API
// déconnecter l'utilisateur et l'orienter vers la page de login
axios.interceptors.response.use(
  (response) => {
    if (response.data.messages && response.data.messages.length > 0) {
      response.data.libellesMessages = ""
      response.data.messages.forEach(message => {
        response.data.libellesMessages += message.libelleMessage + '\n'
      });
      //console.log("messages:", response.data.messages);
    }
    return response;
  },
  (error) => {
    if (!error.response.config.url.includes(netatmoService.url) && (error.response.status === 403 || error.response.status === 401)) {
      store.dispatch('deconnecter')
      router.push('login')
    }
    if (error.response.config.url.includes(netatmoService.url) && (error.response.status === 401 || error.response.status === 403 || 
      (error.response.status === 400 && error.response.data.error.code === 1) )) {
        netatmoService.lireNetAtmoAuthentication()
        .then((response) => {
          if (response.data.clientId && response.data.scope && response.data.redirectUrl && !response.data.authenticated) {
            window.location.replace(netatmoService.redirectToNetatmoOAuth2Dialog(response.data.clientId, response.data.scope, response.data.redirectUrl))
          }
        })
    }
    if (error.response.data.messages && error.response.data.messages.length > 0) {
      error.response.data.libellesMessages = ""
      error.response.data.messages.forEach(message => {
        error.response.data.libellesMessages += message.libelleMessage + '\n'
      });
      // console.log("messages:", error.response.data.messages);
    }
    if (error.response.data.message) {
      error.response.data.libellesMessages = error.response.data.message
      // console.log("messages:", error.response.data.message);
    }
    return Promise.reject(error)
  }
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
